/**
 * Loader de marque « Les deux orbites » — direction C de la planche validée par
 * le fondateur (01/08). Deux arcs — vert (le parti, la terre) et or (le fil) —
 * orbitent en sens inverses autour de l'emblème immobile, posé sur un médaillon
 * blanc circulaire (icône *maskable* : sa zone de sécurité est prévue pour le
 * recadrage rond — et le fond blanc du PNG devient un choix, lisible en Mode
 * Nuit comme en jour).
 *
 * ⚠ Les rotations vivent sur des <span> HTML enveloppants, PAS sur les <circle>
 * SVG : Blink/WebKit refusent de composer les transforms animés sur des enfants
 * SVG (repeint main-thread à 60 fps — au moment précis où l'app est occupée).
 * L'arc lui-même reste statique dans son wrapper qui tourne.
 *
 * L'emblème est PRÉ-CACHÉ (sw.js + <link rel="preload"> dans index.html) : un
 * loader qui dépend du réseau qu'il masque serait absurde hors ligne. Si l'image
 * échoue quand même, elle se masque (onError) — les orbites seules suffisent.
 *
 * Usage :
 *   <GeLoader size="page" label="Chargement…" />   — plein écran, autonome
 *   <GeLoader size="inline" />                     — barres, listes (28px)
 *
 * Accessibilité : avec `label`, le composant est autonome (role="status").
 * Sans `label`, le visuel est aria-hidden — le parent porte alors l'annonce
 * (aria-busy / aria-live) ET le texte visible.
 */
import './GeLoader.css';

const EMBLEME_SRC = '/assets/images/logo/icon-maskable-192x192.png';

export default function GeLoader({ size = 'page', label = '' }) {
  const stage = (
    <span className={`ge-loader ge-loader-${size}`} aria-hidden={label ? undefined : true}>
      <span className="ge-loader-stage" aria-hidden="true">
        <img
          className="ge-loader-embleme"
          src={EMBLEME_SRC}
          alt=""
          width="192"
          height="192"
          decoding="async"
          onError={(e) => { e.target.style.visibility = 'hidden'; }}
        />
        <span className="ge-loader-orbit ge-loader-orbit-vert">
          <svg viewBox="0 0 112 112"><circle className="ge-loader-arc-vert" cx="56" cy="56" r="52" /></svg>
        </span>
        <span className="ge-loader-orbit ge-loader-orbit-or">
          <svg viewBox="0 0 112 112"><circle className="ge-loader-arc-or" cx="56" cy="56" r="47" /></svg>
        </span>
      </span>
      {label && <span className="ge-loader-label">{label}</span>}
    </span>
  );

  if (!label) return stage;
  return (
    <span role="status" aria-live="polite" className="ge-loader-status">
      {stage}
    </span>
  );
}
